import yearlyContractedDialogComponent from './yearly-contracted-dialog.component';

export default angular
  .module('fizyweb.paycell.yearlyContracted', [])
  .component('yearlyContractedDialog', yearlyContractedDialogComponent).name;



// WEBPACK FOOTER //
// src/app/buy/yearly-contracted-info/yearly-contracted-dialog.module.ts